import React, { memo } from 'react';
import { createPortal } from 'react-dom';
import { useModalFacturaEmitida } from '../Modales/Hooks/useModalFacturaEmitida';

import SeccionComprobanteFactura from '../ComponentesFactura/SeccionComprobanteFactura';
import SeccionCalculoFactura from '../ComponentesFactura/SeccionCalculoFactura';
import SeccionTesoreriaFactura from '../ComponentesFactura/SeccionTesoreriaFactura';

const ModalFacturaEmitida = ({ show, onClose, onSuccess, initialData = null, maestros: maestrosProp = {} }) => {
    const hookData = useModalFacturaEmitida({ show, onClose, onSuccess, initialData, maestrosProp });

    if (!show) return null;

    const {
        formData, setFormData, retencionesList, retencionInput, setRetencionInput,
        loading, error, esFacturaB, esComprobanteDirecto, requiereMontoTotalDirecto, calculos,
        clientes, cuentas, areas, conceptosFacturas,
        handleBlurCurrency, handleBlurMontoRetencion, handleClienteChange, handleAreaChange,
        handleConceptoChange, handleCuentaChange, handleAddRetencion, handleRemoveRetencion,
        handleSubmit
    } = hookData;

    return createPortal(
        <div className="fixed inset-0 bg-gray-900 bg-opacity-60 z-[1100] flex items-center justify-center p-4 backdrop-blur-sm transition-opacity text-left font-sans">
            <div className="bg-white rounded-2xl shadow-2xl w-full max-w-5xl h-auto max-h-[95vh] flex flex-col overflow-hidden border border-gray-100 animate-fade-in transition-all duration-300">
                
                {/* HEADER */}
                <div className="flex justify-between items-center px-6 py-4 border-b border-gray-100 bg-blue-50/50 shrink-0">
                    <div className="flex items-center gap-3">
                        <span className="bg-blue-100 text-blue-600 p-2.5 rounded-xl shrink-0">
                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                            </svg>
                        </span>
                        <div>
                            <h3 className="text-lg font-bold text-gray-800 leading-none">
                                {initialData ? 'Gestionar Factura Emitida' : 'Nueva Factura Emitida'}
                            </h3>
                            <p className="text-[10px] text-blue-800/80 font-black mt-1.5 tracking-wider uppercase select-none">
                                Reg. Impositivo • Venta / Comisiones
                            </p>
                        </div>
                    </div>
                    <button onClick={onClose} className="text-gray-400 hover:text-gray-600 transition-colors p-2 hover:bg-slate-50 rounded-full cursor-pointer">
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>

                {/* CUERPO DEL FORMULARIO */}
                <div className="overflow-y-auto p-8 flex-grow bg-white scrollbar-thin scrollbar-thumb-slate-200 scrollbar-track-transparent">
                    <form id="facturaForm" onSubmit={handleSubmit} className="space-y-8">
                        {error && (
                            <div className="p-4 rounded-xl bg-rose-50 border border-rose-200 text-rose-700 text-xs font-bold">
                                ⚠️ {error}
                            </div>
                        )}

                        <SeccionComprobanteFactura
                            formData={formData}
                            setFormData={setFormData}
                            clientes={clientes}
                            areas={areas}
                            conceptosFacturas={conceptosFacturas}
                            handleClienteChange={handleClienteChange}
                            handleAreaChange={handleAreaChange}
                            handleConceptoChange={handleConceptoChange}
                        />

                        <SeccionCalculoFactura
                            formData={formData}
                            setFormData={setFormData}
                            calculos={calculos}
                            esFacturaB={esFacturaB}
                            esComprobanteDirecto={esComprobanteDirecto}
                            requiereMontoTotalDirecto={requiereMontoTotalDirecto}
                            handleBlurCurrency={handleBlurCurrency}
                        />

                        <SeccionTesoreriaFactura
                            formData={formData}
                            setFormData={setFormData}
                            retencionesList={retencionesList}
                            retencionInput={retencionInput}
                            setRetencionInput={setRetencionInput}
                            calculos={calculos}
                            cuentas={cuentas}
                            handleBlurCurrency={handleBlurCurrency}
                            handleBlurMontoRetencion={handleBlurMontoRetencion}
                            handleCuentaChange={handleCuentaChange}
                            handleAddRetencion={handleAddRetencion}
                            handleRemoveRetencion={handleRemoveRetencion}
                        />
                    </form>
                </div>

                {/* BOTONERA INFERIOR */}
                <div className="px-6 py-4 border-t border-gray-100 flex justify-end gap-3 bg-gray-50 shrink-0">
                    <button type="button" onClick={onClose} className="px-6 py-2.5 rounded-full border border-slate-300 bg-white text-slate-700 font-bold uppercase text-xs hover:bg-slate-50 shadow-sm transition-all transform active:scale-95 select-none cursor-pointer">Cancelar</button>
                    <button type="submit" form="facturaForm" disabled={loading} className="px-8 py-2.5 rounded-full text-white font-bold transition-all uppercase text-xs transform active:scale-95 min-w-[180px] shadow-lg select-none bg-blue-600 hover:bg-blue-700 shadow-blue-100 cursor-pointer">
                        {loading ? 'Guardando...' : 'Confirmar cambios'}
                    </button>
                </div>

            </div>
        </div>,
        document.body
    );
};

export default memo(ModalFacturaEmitida);